import { get, post } from '../../../../services/request';

// Fetch Forecast Reports with Pagination
export const getForecastReportsWithPagination = async (payload) => {
    try {
        const response = await post('ForecastingDemand/GetAllForecastingDemandReportsWithPagination', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Delete Forecast Report
export const deleteForecastReport = async (payload) => {
    try {
        const response = await post(`ForecastingDemand/DeleteForecastingDemandReports`, payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch Notes Edit Data

export const getForecastNotesEditData = async (reportId) => {
    try {
        const response = await get(`ForecastingDemand/GetForecastDemandNotesById?ForecastDemandMasterId=${reportId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Save Notes Data
export const saveForecastNotesData = async (payload) => {
    try {
        const response = await post('ForecastingDemand/UpdateForecastDemandNotes', payload);
        return response;
    } catch (error) {
        throw error;
    }
};

// Fetch All Dropdown Data for Forecasting Demand
export const fetchAllForecastingDemandDropdowns = (data) => {
    return get(`ForecastingDemand/GetAllForecastingDemandDropdowns?ForecastDemandId=${data}`);
};

// Fetch Forecasting Demand By Id With Pagination
export const fetchForecastingDemandByIdWithPagination = (data) => {
    return post(`ForecastingDemand/GetForecastingDemandByIdWithPagination`, data);
};

export const fetchForecastDemandSitePriorityDrillThrough = (data) => {
    return post(`ForecastingDemand/GetForecastDemandSitePriorityDrillthrough`, data);
};

export const saveForecastingDemandReports = (data) => {
    return post(`ForecastingDemand/SaveForecastingDemandReports`, data);
};

//Demand Table Tab Services
export const getForecastFilterDropdowns = () => {
    return get('ForecastingDemand/GetAllForecastingDemandReportDropdowns');
};